import { Action, Types } from "./planningParams.actions"
import { PlanningParamsState } from "./types"

const initialState: PlanningParamsState = {
  data: {
    planning: {
      from: undefined,
      to: undefined,
    },
    absences: {
      from: undefined,
      to: undefined,
    },
  },
}

export default (state = initialState, action: Action): PlanningParamsState => {
  switch (action.type) {
    case Types.SET: {
      const { type, ...data } = action.payload.data
      return {
        ...state,
        data: {
          ...state.data,
          [type]: data,
        },
      }
    }

    default:
      return state
  }
}
